import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import config from "../config";

const ContactInformation = ({ title = "Contact Information" }) => {
  const { contactInfo, companyFullName, contactAddress } = config;

  return (
    <Box sx={{ mt: 5, mb: 5 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 3,
          color: "#0693e3",
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 3,
        }}
      >
        {/* India Contact */}
        <Paper
          sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            border: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#FF895D" }}>
            For India
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>{contactInfo.india.name}</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: "#666" }}>
            {contactInfo.india.title}
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>Email:</strong> {contactInfo.india.email1}
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            {contactInfo.india.email2}
          </Typography>
          <Typography variant="body2">
            <strong>Phone:</strong> {contactInfo.india.phone}
          </Typography>
        </Paper>

        {/* USA Contact */}
        <Paper
          sx={{
            p: 3,
            backgroundColor: "#f8f9fa",
            border: "1px solid #e0e0e0",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#FF895D" }}>
            For USA
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>{contactInfo.usa.name}</strong>
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: "#666" }}>
            {contactInfo.usa.title}
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>Email:</strong> {contactInfo.usa.email1}
          </Typography>
          <Typography variant="body2">
            {contactInfo.usa.email2}
          </Typography>
        </Paper>
      </Box>

      {/* Company Info */}
      <Paper
        sx={{
          p: 3,
          mt: 3,
          backgroundColor: "#f0f7ff",
          border: "1px solid #b3e5fc",
        }}
      >
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Company:</strong> {companyFullName}
        </Typography>
        <Typography variant="body2">
          <strong>Address:</strong> {contactAddress}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ContactInformation;
